<script>
// import {StringUtil} from '@/utils/StringUtil'
import qlEditor from 'vue-quill-editor'
export default {
  components: {
    qlEditor
  },
  data () {
    return {
      title: 'イべント編集'
    }
  },
  props: {
    eventInfoModel: {
      createTime: null,
      createUser: '',
      eventDate: '',
      eventId: '',
      eventName: '',
      eventNote: '',
      eventPhotoUrl: '',
      updateTime: null,
      updateUser: ''
    },
    option: {
      imgs: null,
      file: null,
      chooseImageFlag: false
    }
  },
  methods: {
    // 保存图片后登陆
    saveImage () {
      new Promise((resolve, reject) => {
        if (this.option.file !== null) {
          let file = this.option.file
          let formData = new FormData()
          formData.append('uploadFile', file)
          this.$axios.post('shift/saveEventImage', formData)
            .then((response) => {
              this.eventInfoModel.eventPhotoUrl = response.data.pictureUrl
              resolve()
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          if (this.option.chooseImageFlag) {
            this.eventInfoModel.eventPhotoUrl = null
          }
          resolve()
        }
      }).then(() => {
        this.eventUpdate()
      })
    },
    goback () {
      this.$router.go(-1)
    },
    // 获得8位日期格式
    dateyymmdd (val) {
      if (val) {
        let yymmdd = val.split('(')[0]
        let year = yymmdd.split('年')[0]
        let month = yymmdd.split('月')[0].split('年')[1]
        let day = yymmdd.split('月')[1].split('日')[0]
        if (month.length !== 2) {
          month = '0' + month
        }
        if (day.length !== 2) {
          day = '0' + day
        }
        return year + month + day
      } else {
        return ''
      }
    },
    eventUpdate () {
      let eventInfoModel = this.eventInfoModel
      eventInfoModel.eventDate = this.dateyymmdd(eventInfoModel.eventDate)
      var paramaterObj = {
        'viewModelData': eventInfoModel
      }
      this.$axios.post('shift/updateShiftEvent', paramaterObj)
        .then((response) => {
          // 更新session(只有eventDate, eventName, eventNote, eventPhotoUrl)
          sessionStorage.setItem('shiftEventInfo', JSON.stringify({eventInfo: eventInfoModel}))
          this.$router.go(-1)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<template>
   <div class="col-md-12 column">
    <div class="modal fade" id="modal-container-shift-event-detail" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div id="div_layer" class="modal-dialog" style="width:72%;">
        <div class="modal-content">
            <div class="modal-header" style="text-align:center; border-bottom:0px">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png"/></button>
                <span class="modal-title F3-M-27">{{title}}</span>
            </div>
            <div class="modal-body">
                <div class="col-md-12 column">
                  <table class="table table-bordered window-table">
                    <col style="width: 25%" />
                    <col style="width: 15%" />
                    <col style="width: 60%" />
                    <tbody>
                      <tr>
                        <td class="bgc3 F2-M-19" colspan="3">イべント項目</td>
                      </tr>
                      <tr>
                        <td class="td-value" rowspan="3" style="padding:10px">
                          <div class="img-bg">
                            <img v-show="option.imgs" :src="option.imgs" class="img-style">
                            <div v-show="!option.imgs" class="bgc10 F2-M-18">No Image</div>
                          </div>
                        </td>
                        <td class="td-key F3-R-15 bgc8">イべント名</td>
                        <td class="td-value word-breaker">{{this.eventInfoModel.eventName}}</td>
                      </tr>
                      <tr>
                        <td class="td-key F3-R-15 bgc8">開催日</td>
                        <td class="td-value">{{this.eventInfoModel.eventDate}}</td>
                      </tr>
                      <tr>
                        <td class="td-key F3-R-15 bgc8">開催概要</td>
                        <td class="td-value">
                            <div class="ql-editor" style="width:100%" v-html="this.eventInfoModel.eventNote">
                            </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br>
                <div>
                  <button class="window-button" data-dismiss="modal" @click="saveImage">確定</button>
                </div>
            </div>
        </div>
      </div>
    </div>
   </div>
</template>
<style lang="scss" scoped>
@import "../assets/css/C00.css";
// 表格内的文本换行
.word-breaker{
  word-break: break-all;
}
.ql-editor{
  height:300px;
  padding: 0%;
  font-size: 1.09vw;
  word-break:break-all
}
.modal-header{
  border-bottom: 0px;
}
.modal-body{
  padding-left: 40px;
  padding-right: 40px;
  height: 100%;
}
.img-bg{
  color: #fff;
  width:100%;
  height:200px;
  line-height: 200px;
  text-align: center;
  // max-height: 500px;
}
.img-style{
  width: 100%;
  height: 100%;
}
  //表格
.window-table{
  font-size: 18px;
  border: 1px solid #959595;
  // table-layout:fixed;
  }
 //边框
.table-bordered>tbody>tr>td{
  border: 1px solid #959595;
}
.td-key{
vertical-align: middle;
 background-color: #DDDDDD;
 border: 1px solid #959595;
}
//关于值的列的设置（深色）
.td-value{
  padding:9px;
  padding-left: 20px;
  text-align: left;
  border: 1px solid #959595;
}
</style>



// WEBPACK FOOTER //
// src/components/ShiftEventDetailWindowMask.vue